<template>
	<div>
        <Loading :value="loading" ></Loading>



    <!-- MODAL LISTE DES INTERVENTIONS -->
    <v-dialog v-model="dialogInterv" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card >
        <v-toolbar style="flex: 0 0 auto;" dark class="primary">
          <v-toolbar-title>
            <span  >Liste des demandes d'intervention  </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="closeDialog()" dark><v-icon>close</v-icon> </v-btn>
        </v-toolbar>
        <v-container fluid grid-list-md >
        <div class="text-xs-right mt-3" >
             <v-tooltip top>
                <v-btn slot="activator" icons color="green"  @click.stop="imprimeListeDemande('PDF')" dark>Imprimer PDF <v-icon right>print</v-icon></v-btn>
                     PDF
                </v-tooltip>
            <v-tooltip top>
                <v-btn slot="activator" icons color="warning"  @click.stop="imprimeListeDemande('EXC')" dark>Imprimer EXCEL <v-icon right>print</v-icon></v-btn>
                   Excel
            </v-tooltip>

             <v-tooltip top>
                <v-btn slot="activator" icons color="primary" @click.stop="modalAjoutInterv()" dark>Ajouter <v-icon right>add</v-icon></v-btn>
                    Ajouter une nouvelle intervention
            </v-tooltip>
        </div>


            <v-layout row>
                <v-flex xs12>
                        <data-tables :data="listIntervention"   >
                            <el-table-column prop="vehicule" label="Véhicule" width="380" fixed="left">
                                <template slot-scope="scope">
                                    <v-chip label text-color="white" color="primary">
                                        {{scope.row.vehicule}} <v-icon right>directions_car</v-icon>
                                    </v-chip>
                                </template>
                            </el-table-column>
                            <el-table-column prop="date" label="Date" width="280">
                                <template slot-scope="scope">
                                    <v-chip outline label text-color="primary" color="primary">
                                        {{scope.row.date}}
                                    </v-chip>
                                </template>
                            </el-table-column>
                            <el-table-column prop="type" label="Type" width="160">
                                <template slot-scope="scope">
                                    <v-chip v-if="scope.row.type == 'Curative'" label text-color="white" color="red">
                                        REPARATION
                                    </v-chip>
                                    <v-chip v-else label text-color="white" color="orange">
                                        MAINTENANCE
                                    </v-chip>
                                </template>
                            </el-table-column>
                             <el-table-column prop="categprie" label="Catégorie" width="160">
                                <template slot-scope="scope">
                                    <v-chip text-color="white" color="primary">
                                     {{scope.row.categorie}}
                                    </v-chip>
                                </template>
                            </el-table-column>
                            <el-table-column prop="demandeur" label="Demandeur" width="180"></el-table-column>
                            <el-table-column prop="etat" label="Etat / Etape" >
                                <template slot-scope="scope">
                                    <v-chip v-if="scope.row.etat == 0" label text-color="white" color="primary">
                                        DIAGNOSTIQUE EN ATTENTE
                                    </v-chip>
                                    <v-chip v-else-if="scope.row.etat == 1" label text-color="white" color="warning">
                                        EN ATTENTE DE VALIDATION DU DEVIS
                                    </v-chip>
                                    <v-chip v-else-if="scope.row.etat == 2" label text-color="white" color="red">
                                        INTERVENTION REFUSEE
                                    </v-chip>
                                    <v-chip v-else-if="scope.row.etat == 3" label text-color="white" color="green">
                                        DEVIS VALIDE
                                    </v-chip>
                                    <v-chip v-else-if="scope.row.etat == 4" label text-color="white" color="red">
                                        DIVIS REFUSE
                                    </v-chip>
                                     <v-chip v-else-if="scope.row.etat == 5" label text-color="white" color="green">
                                        INTERVENTION TERMINEE
                                    </v-chip>
                                    <v-chip v-else-if="scope.row.etat == 6" label text-color="white" color="orange">
                                        INTERVENTION EN COURS
                                    </v-chip>
                                </template>
                            </el-table-column>
                            <el-table-column label="Action" fixed="right" width="150">
                                <template slot-scope="scope">
                                    <div class="text-xs-center">
                                        <v-tooltip top>
                                            <v-btn  slot="activator" @click="showIntervention(scope.row)" fab dark small color="blue">
                                                <v-icon dark>list</v-icon>
                                            </v-btn>
                                            Détails
                                        </v-tooltip>
                                        <v-tooltip top>
                                            <!-- && droitAcces.intervention -->
                                            <v-btn v-if="scope.row.etat == 0" slot="activator" @click="modalEditInterv(scope.row)" fab dark small color="primary">
                                                <v-icon dark>edit</v-icon>
                                            </v-btn>
                                            Modifier
                                        </v-tooltip>

                                         <v-tooltip top>
                                            <v-btn  v-if="scope.row.etat == 0 && droitAcces.new_diagnostique"  slot="activator" @click="modalDiagnostic(scope.row)" fab dark small color="teal">
                                            <v-icon dark>build</v-icon>
                                            </v-btn>
                                            Effectuer le diagnostique
                                        </v-tooltip>

                                         <v-tooltip top>
                                            <v-btn  v-if="scope.row.etat == 3 && droitAcces.new_programmation "  slot="activator" @click="modalPlaning(scope.row)" fab dark small color="green">
                                            <v-icon dark>view_agenda</v-icon>
                                            </v-btn>
                                            Planifier l'intervention
                                        </v-tooltip>

                                         <v-tooltip top>
                                            <v-btn  v-if="scope.row.etat == 6 && droitAcces.new_fin_intervention "  slot="activator" @click="modalRapport(scope.row)" fab dark small color="yellow">
                                            <v-icon dark>list</v-icon>
                                            </v-btn>
                                            Rapport de depannage
                                        </v-tooltip>


                                        <v-tooltip top>
                                            <v-btn v-if="droitAcces.Intervention_delete && scope.row.etat == 0  " slot="activator" @click.stop="dialogSupr = true; idDmdInterv = scope.row.id;" fab dark small color="red">
                                              <v-icon dark>delete</v-icon>
                                            </v-btn>
                                            Supprimer
                                        </v-tooltip>

                                        <!-- <v-tooltip top>
                                            <v-btn slot="activator" @click="imprimerDemande(scope.row)" fab dark small color="orange">
                                                <v-icon dark>print</v-icon>
                                            </v-btn>
                                            Imprimer
                                        </v-tooltip> -->
                                    </div>
                                </template>
                            </el-table-column>
                        </data-tables>

                </v-flex>

            </v-layout>
        </v-container>




      </v-card>
    </v-dialog>
    <!-- MODAL LISTE DES INTERVENTIONS -->

    <!-- MODAL SUPPRESSION DEMANDE -->
     <v-dialog v-model="dialogSupr" persistent max-width="50%">
      <v-card>
        <v-card-title class="headline">Supprimer cet enregistrement ?</v-card-title>
        <v-card-text>
            <v-layout wrap>
                <v-flex xs12 class="mb-2">
                     <el-alert
                        title="La suppression est définitive"
                        :closable="false"
                        show-icon
                        type="error">
                    </el-alert>
                </v-flex>
                <v-flex xs12>
                    <p class="grey--text font-weight-thin body-1">INTERVENTION</p>
                    <p class="black--text .font-weight-regular subheading" >INTERV-{{idDmdInterv}}</p>
                </v-flex>
            </v-layout>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1"  dark @click="dialogSupr = false">Annuler <v-icon right>remove_circle</v-icon></v-btn>
          <v-btn color="red darken-1" dark  @click="deleteInterv()">Supprimer <v-icon right>delete</v-icon></v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

      <!-- MODAL rapport intervention -->
      <v-dialog v-model="dialogRapport" max-width="750" :persistent="true"   transition="dialog-bottom-transition" scrollable>
            <v-card tile>
                <v-toolbar card dark color="primary">
                    <v-toolbar-title>Rapport de fin pour l'intervention INTERV-{{idDmdInterv}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click.native="dialogRapport = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <el-form id="formRapport"  label-width="170px"  :model="formRapport" :rules="rulesformRapport" ref="formRapport" class="demo-form-inline">

                    <v-layout row >
                        <v-flex xs4 >

                                <v-flex xs6 class="mr-2" >
                                    <v-avatar :tile="true" size="170px" height="120px" color="grey lighten-4"> <img :src="image1" alt="avatar"></v-avatar>
                                        <v-layout row>
                                            <input name="image1" type="file" style="display:none" ref="file1" accept="image/*" @change="onFileImage1Picked"/>
                                            <v-btn color="primary" class="white--text" required @click.native="$refs.file1.click()"><v-icon right dark>cloud_upload</v-icon></v-btn>
                                            <div class="font-weight-thin" >Fichier au format (JPEG,PNG,PDF) avec une taille de 1048 ko maximale</div>
                                        </v-layout>
                                </v-flex>

                        </v-flex>

                        <v-flex xs8 >
                            <el-form-item style="width:100%" label="Remarque"  prop="rapport" >
                                <el-input
                                            style="width:100%"
                                            name="remarque"
                                            type="textarea"
                                            :rows="6"
                                            placeholder="Rapport"
                                            v-model="formRapport.remarque">
                                </el-input>
                            </el-form-item >
                        </v-flex>
                    </v-layout>
                    <el-form-item  class="text-xs-right" >
                        <v-btn color="grey"  @click="resetForm('formRapport')" dark>Annuler <v-icon right>remove_circle</v-icon></v-btn>
                        <v-btn icons dark color="green" @click="submitFormRapport('formRapport')">Enregistrer<v-icon right>add</v-icon></v-btn>
                    </el-form-item>
                </el-form>

                </v-card-text>
                <div style="flex: 1 1 auto;"></div>
            </v-card>
        </v-dialog>
    <!-- MODAL rapport intervention -->

    <!-- MODAL planification -->
      <v-dialog v-model="dialogPlanification" max-width="750" :persistent="true"   transition="dialog-bottom-transition" scrollable>
            <v-card tile>
                <v-toolbar card dark color="primary">
                    <v-toolbar-title>Planifier une intervention pour la demande INTERV-{{idDmdInterv}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click.native="dialogPlanification = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <el-form id="formPlanning"  label-width="150px"  :model="formPlanning" :rules="rulesformPlanning" ref="formPlanning" class="demo-form-inline">
                        <v-layout row>
                            <v-flex xs6>
                             <el-form-item label="Date et heure debut" prop="dateDbt">
                                <el-date-picker v-model="formPlanning.dateDbt" format="d-MM-yyyy HH:mm" value-format="yyyy-MM-d HH:mm" name="dateDbt" type="datetime" placeholder="Date de debut" style="width:100%" ></el-date-picker>
                            </el-form-item>
                            </v-flex>

                            <v-flex xs6>
                             <el-form-item label="Date et heure fin" prop="dateFin">
                                <el-date-picker v-model="formPlanning.dateFin" format="d-MM-yyyy HH:mm" value-format="yyyy-MM-d HH:mm" name="dateFin" type="datetime" placeholder="Date de fin" style="width:100%" ></el-date-picker>
                            </el-form-item>
                            </v-flex>
                        </v-layout>

                        <v-layout row>
                             <v-flex xs6>
                             <el-form-item label="Kilometrage" prop="kilometarge">
                                <el-input type="number" :min="0.0" placeholder="Kilometrage" name="kilometrage" v-model="formPlanning.kilometrage" style="width:100%" ></el-input>
                            </el-form-item>
                            </v-flex>
                        </v-layout>

                    <el-form-item  class="text-xs-right" >
                        <v-btn color="grey"  @click="resetForm('formPlanning')" dark>Annuler <v-icon right>remove_circle</v-icon></v-btn>
                        <v-btn icons dark color="green" @click="submitFormPlanning('formPlanning')">Enregistrer<v-icon right>add</v-icon></v-btn>
                    </el-form-item>
                </el-form>

                </v-card-text>
                <div style="flex: 1 1 auto;"></div>
            </v-card>
        </v-dialog>
    <!-- MODAL planification -->

    <!-- Modal de la demande d'intervention -->
        <AjoutIntervention :intervDetail = intervDetail   :show = showModalInterv @close="showModalInterv= false;listeIntervention()" ></AjoutIntervention>
    <!-- Modal de la demande d'intervention  -->

    <!-- Modal du diagnostique -->
        <AjoutDiagIntervention :demandeDetail = intervDetail   :show = showModalDiagnostic @close="showModalDiagnostic= false;listeIntervention()" ></AjoutDiagIntervention>
    <!-- Modal du diagnostique -->

    <!-- Modal Detail intervention -->
        <DetailIntervention :intervDetail = intervDetail   :show = showModalIntervDetail @close="showModalIntervDetail= false;" ></DetailIntervention>
    <!-- Modal Detail intervention -->


	</div>
</template>


<script>
    import Loading from '@/components/Loading'
    import AjoutIntervention from '@/components/intervention/AjoutIntervention'
    import AjoutDiagIntervention from '@/components/intervention/AjoutDiagIntervention'
    import DetailIntervention from '@/components/intervention/DetailIntervention'
    export default {
    components:{ Loading,AjoutIntervention,AjoutDiagIntervention,DetailIntervention },
        name: "InterventionIndex",
        props:["show"],
        data()
        {
         return {
            //data general
                notif: JSON.parse(sessionStorage.getItem('sessionNotif')),
                domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
                user: JSON.parse(sessionStorage.getItem('userInfo')),
                roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
                droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
            labelPosition: 'left',
            dialogInterv: false,
            listIntervention: [],
            loading: false,


            //Ajout intervention
            showModalInterv: false,
            intervDetail: {},

            //Modal diagnostic
             showModalDiagnostic: false,

             //Planification
             idDmdInterv: '',
             dialogPlanification: false,
             formPlanning:{},
               rulesformPlanning: {

                   dateDbt: [
                      {  required: true, message: 'Choisir une date de debut', trigger: 'change' }
                    ],
                    dateFin: [
                      { required: true, message: 'Choisir une date de fin', trigger: 'change' }
                    ],
                     kilometrage: [
                      {  required: true, message: 'Saisir le Km au compteur', trigger: 'change' }
                    ],

                  },
            //Rapport de depannage
            formRapport:{},
               rulesformRapport: {


                  },
            dialogRapport : false,
            image1: "/static/img-doc.png",
            dialogSupr: false,

            //detail intervention
            showModalIntervDetail: false

         }
        },

        computed:{

        },
         watch: {
            show : function(newValue, oldvalue){
               this.dialogInterv = newValue
               if(newValue == true)
               {
                  this.listeIntervention()
               }else {

               }
            }
        },

        methods: {
             resetForm(formName)
             {
                this.$refs[formName].resetFields();
            },
             onFileImage1Picked(event)
            {
                const files = event.target.files
                let filename = files[0].name
                if (filename.lastIndexOf(".") <= 0)
                {
                    return alert("Veuillez selectionner un  format de fichier valide ")
                }

                const fileReader = new FileReader()
                fileReader.addEventListener("load", () => {
                    this.image1 = fileReader.result
                })

                fileReader.readAsDataURL(files[0])
                this.file1 = files[0]
            },

           showIntervention (item) {
                this.intervDetail =  item
                this.showModalIntervDetail = true
            },

        modalPlaning(item)
        {
            this.idDmdInterv =  item.id,
            this.dialogPlanification = true
        },

         modalRapport(item)
        {
            this.idDmdInterv =  item.id,
            this.dialogRapport = true
        },

        listeIntervention()
        {
            this.loading = true;
             let url = '';
             if(this.droitAcces.intervention){
                url = this.domaine + 'intervention/index'
             }
             else {
                url = this.domaine + 'intervention/demandeur/'+ this.user.id+'/index'
             }
            this.$http.get(url).then(response => {
            this.loading = false;
            this.listIntervention = response.body.intervention

        }, (errRep)=> {
            this.loading = false
            this.$message.error("Une erreur lors du chargement de la liste des interventions'")
            })
        },
        submitFormPlanning(formName)
        {
            this.loading = true
            this.$refs[formName].validate( (valid) =>
            {
                if(valid)
                {
                    var form = document.getElementById('formPlanning')
                    var data = new FormData(form)
                    data.append('idUser', this.user.id)
                    data.append('dateD', this.formPlanning.dateDbt)
                    data.append('dateF', this.formPlanning.dateFin)
                    data.append('kilometrage', this.formPlanning.kilometrage)
                    //data.append('etape', etape)

                    let url = this.domaine + 'intervention/new/'+ this.idDmdInterv +'/programmation'
                    this.$http.post(url, data).then(response => {
                    this.resetForm('formPlanning')
                    this.loading = false
                    this.$notify({
                        title: 'ENREGISTREMENT REUSSI',
                        message: "Programmation enregistrée avec succès.",
                        type: 'success',
                        position: 'top-center'
                    })

                    this.dialogPlanification = false;
                    this.listeIntervention()
                    },response => {
                        this.resetForm('formPlanning')
                        this.dialogPlanification = false;
                        this.loading = false
                        this.$message.error("Erreur lors de l'enregistrement de la planification")
                    })
                }
            })
        },

          submitFormRapport(formName)
        {
            this.loading = true
            this.$refs[formName].validate( (valid) =>
            {
                if(valid)
                {
                    var form = document.getElementById('formRapport')
                    var data = new FormData(form)
                    data.append('idUser', this.user.id)

                    //data.append('etape', etape)

                    let url = this.domaine + 'intervention/new/'+ this.idDmdInterv +'/fin/intervention'
                    this.$http.post(url, data).then(response => {
                    this.loading = false
                    this.$notify({
                        title: 'ENREGISTREMENT REUSSI',
                        message: "Rapport enregistrée avec succès.",
                        type: 'success',
                        position: 'top-center'
                    })

                    this.dialogRapport = false;
                    this.listeIntervention()
                    },response => {
                        this.dialogRapport = false;
                        this.loading = false
                        this.$message.error("Erreur lors de l'enregistrement du rapport de depannage")
                    })
                }
            })
        },

         imprimerDemande (ligne) {
                this.interventionCourant = ligne
                let url = this.domaine + 'intervention/' + this.interventionCourant.id + '/imprimer'
                this.$http.get(url).then(response => {
                    if (response.body) {
                    }
                })
                window.open(url)
            },

         deleteInterv () {
                this.loading = true
                let url = this.domaine + 'intervention/' + this.idDmdInterv + '/delete'
                this.$http.get(url).then(response => {
                     this.loading = false

                        this.$notify({
                            title: 'SUPPRESSION',
                            message: 'Intervention supprimée avec succès.',
                            type: 'success',
                            position: 'top-center'
                        })
                        this.dialogSupr = false
                        this.loading = false
                        this.listeIntervention()
                },response => {
                        this.dialogRapport = false;
                        this.loading = false
                        this.$message.error("Erreur lors de la suppression de l'intervention")
                    })
            },


        closeDialog()
        {
            this.$emit('close')
        },

        successNotif(mess = "")
        {
            this.$notify({
                    title: 'ENREGISTREMENT REUSSI',
                    message: mess,
                    type: 'success',
                    position: 'top-center'
            })
        },

        modalAjoutInterv()
        {
            this.intervDetail = {}
            this.showModalInterv = true
        },
         modalEditInterv(item)
        {
            this.intervDetail = item
            this.showModalInterv = true
        },
         modalDiagnostic(item)
        {
            this.intervDetail = item
            this.showModalDiagnostic = true
        },
         imprimeListeDemande (type) {
                let url = ""
                if(type == "PDF"){
                  if(this.droitAcces.intervention){
                    url = this.domaine+"intervention/imprimerPDF/liste"
                  }else{
                    url = this.domaine+"intervention/imprimerPDF/"+this.user.id +"/liste"
                  }
              }else {
                 if(this.droitAcces.intervention){
                    url = this.domaine+"intervention/imprimerEXC/liste"
                  }else{
                   url = this.domaine+"intervention/imprimerEXC/"+this.user.id +"/liste"
                  }
                }
                window.open(url)
            },



      },


        mounted(){

        }

    }
    </script>



// WEBPACK FOOTER //
// src/components/intervention/Intervention_index.vue